import { JSX } from "react";
import cx from "classnames";
import { valueOrDashes } from "@app/shared/utility/valueOrDashes";
import InfoIndicator from "@app/shared/InfoIndicator";

interface ClaimAmounts {
  commercialClaimAmount?: number;
  medicaidClaimAmount?: number;
  medicareClaimAmount?: number;
  vaClaimAmount?: number;
  tricareClaimAmount?: number;
  totalClaimAmount?: number;
}

interface ProviderClaimAmountsProps {
  claimAmounts: ClaimAmounts;
  showVA: boolean;
  showTricare: boolean;
  className?: string;
  testId: string;
}

/**
 * ProviderClaimAmounts component
 * This component displays claim amounts for a provider.
 */
const ProviderClaimAmounts = (props: ProviderClaimAmountsProps): JSX.Element => {
  return (
    <div
      className={cx({ [props.className]: !!props.className, "data-box": true })}
      data-testid={props.testId}
    >
      <div className="data-box-header">
        Total ($) <InfoIndicator className={"informational-indicator"} tooltipTitle="Total dollar amount spent." />
      </div>
      <div className="data-box-content">
        Total: {valueOrDashes(props.claimAmounts.totalClaimAmount, true)}
      </div>
      <div className="data-box-content">
        Medicare: {valueOrDashes(props.claimAmounts.medicareClaimAmount, true)}
      </div>
      <div className="data-box-content">
        Medicaid: {valueOrDashes(props.claimAmounts.medicaidClaimAmount, true)}
      </div>
      <div className="data-box-content">
        Commercial: {valueOrDashes(props.claimAmounts.commercialClaimAmount, true)}
      </div>
      {props.showVA && (
        <div className="data-box-content">
          VA: {valueOrDashes(props.claimAmounts.vaClaimAmount, true)}
        </div>
      )}
      {props.showTricare && (
        <div className="data-box-content">
          TRICARE: {valueOrDashes(props.claimAmounts.tricareClaimAmount, true)}
        </div>
      )}
    </div>
  );
};

export default ProviderClaimAmounts;